// App.jsx
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import ContentSection from './components/ContentSection';
import GraphicSection from './components/GraphicSection';
import QualificationsSection from './components/QualificationsSection';
import ReviewSection from './components/ReviewSection';
import OfferSection from './components/OfferSection';
import Footer from './components/Footer';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AGBPage from './pages/AGBPage';
import './App.css';

const MainContent = ({ scrollY, activeGraphic, handleGraphicClick }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div 
      className="parallax"
      style={{ backgroundPositionY: `${scrollY * -0.3}px` }}
    >
      {!isMobile && <Header />}
      <div id="startseite">
        <HeroSection />
      </div>
      <div className="content-section">
        <h2 className="mission-subtitle">Meine Mission? - Deine Emotion!</h2>
        <div id="meine mission">
          <ContentSection />
        </div>
        <div id="kontakt">
          <ContactSection />
        </div>
        <h2 className="section-title">Befreie dich von emotionaler Last und finde deine innere Stärke</h2>
        <div id="angebot">
          <GraphicSection activeGraphic={activeGraphic} onGraphicClick={handleGraphicClick} />
        </div>
        <div id="erfolgsstory">
          <QualificationsSection />
        </div>
        <div id="review">
          <ReviewSection />
        </div>
        <div id="offer">
          <OfferSection />
        </div>
        <Footer />
      </div>
    </div>
  );
};


const App = () => {
  const [scrollY, setScrollY] = useState(0);
  const [activeGraphic, setActiveGraphic] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGraphicClick = (graphic) => {
    setActiveGraphic(graphic === activeGraphic ? null : graphic);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<MainContent scrollY={scrollY} activeGraphic={activeGraphic} handleGraphicClick={handleGraphicClick} />}
        />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/agb" element={<AGBPage />} />
      </Routes>
    </Router>
  );
};

export default App;
